export class KasseState {
    public ausweis: number;
    public user: number;
    public vorname: string;
    public nachname: string;
    public essen: string;
    public preis: number;
}